import { keywords } from "../keywords.js";
import { TestParserOptions } from "../../options/testParserOptions.js";

/**
 * Checks if a property name matches the 'only' keyword or literal.
 * 
 * @param name - The property name.
 * @param options - Parser options.
 * @returns True if the property indicates an 'only' execution filter.
 */
export function isOnlyField(name: string, options: TestParserOptions): boolean {
  return name === keywords.only
    || (options.parserFlags!.allowLiteralOnly && name === "only");
}

/**
 * Checks if an object has an 'only' property (via metadata or literal).
 * 
 * @param value - The object to check.
 * @param options - Parser options.
 * @returns True if the object has an 'only' property.
 */
export function hasOnly(value: any, options: TestParserOptions): boolean {
  return Object.hasOwn(value, keywords.only)
    || (options.parserFlags!.allowLiteralOnly && Object.hasOwn(value, "only"))
}

/**
 * Checks if an object has an 'only' decorator with a supported expression.
 * 
 * @param value - The object to check.
 * @returns True if the object has a valid 'only' decorator.
 */
export function hasOnlyDecorator(value: any): boolean {
  return Object.hasOwn(value, keywords.only)
    && isOnlyExpressionSupported(value[keywords.only]);
}


/**
 * Validates if an 'only' expression (number, boolean, or '*') is supported.
 * 
 * @param expression - The expression value.
 * @returns True if the expression is a supported type.
 */
export function isOnlyExpressionSupported(expression: any): boolean {
  const isNumber = typeof (+expression) === 'number' && +expression > 0;
  const isStar = expression === '*';

  return isNumber || isStar;
}
